import { CUSTOMER_STATUSES } from "./CustomerStatus";

export const QUICK_FILTERS = [...CUSTOMER_STATUSES] as const;

export const QUICK_FILTER_TEST = "test";

export const QUICK_FILTER_NO_PARENT = "noParent";
